import { Card, Empty, Typography } from "antd";
import { Line } from "@ant-design/plots";
import { useQuery } from "@apollo/client";

import { ENDPOINT_METRICS_QUERY } from "../../helpers/graphql/endpoint";

export function EndpointMetrics({
  project,
  network,
  chain,
  archive,
  interval,
  showLast,
  height,
}: any) {
  const { loading, data } = useQuery(ENDPOINT_METRICS_QUERY, {
    variables: { projectId: project.id, network, chain, archive, interval, showLast },
  });

  const endpointMetrics =
    data?.endpointMetrics.length > 0
      ? data?.endpointMetrics
      : [
          {
            count: 0,
            timestamp: Date.now(),
          },
        ];

  const config = {
    data: endpointMetrics,
    smooth: true,
    xField: "timestamp",
    yField: "count",
    xAxis: {
      tickCount: 10,
      label: {
        formatter: (v: string) =>
          new Date(parseInt(v))
            .toISOString()
            .replace("T", " ")
            .split(".")[0]
            .slice(0, -3)
            .split(" ")[1],
      },
    },
    yAxis: {
      maxLimit: endpointMetrics && endpointMetrics?.[0].count > 0 ? null : 4,
    },
    tooltip: {
      showTitle: false,
      formatter: ({ timestamp, count }: any) => {
        return {
          name: new Date(timestamp).toISOString().replace("T", " ").split(".")[0].slice(0, -3),
          value: Intl.NumberFormat("en-US", {
            notation: "compact",
            maximumFractionDigits: 1,
          }).format(count),
        };
      },
    },
    slider: {
      start: 0.5,
      end: 1,
      formatter: (v: Date) =>
        new Date(v).toISOString().replace("T", " ").split(".")[0].slice(0, -3),
    },
  };

  return loading ? (
    <Card loading={true} className="card-loading" />
  ) : (
    <Card className={"card-body"} title="Request count">
      <Typography.Text style={{ color: "grey" }}></Typography.Text>

      {endpointMetrics ? <Line {...config} height={height} /> : <Empty />}
    </Card>
  );
}
